import type { MaybeRef, Ref } from "vue";

export const SignatureQueryKeys = {
  all: ["signature"] as const,
  // TODO : number -> SiteId
  bySiteId: (siteId: MaybeRef<number>) => [...SignatureQueryKeys.all, "site", siteId] as const,
  findSignatureDetails: (siteId: Ref<number>) => [...SignatureQueryKeys.bySiteId(siteId), "details"] as const,
  sendSignatureReminder: (subscriberSignatureId: number) =>
    [...SignatureQueryKeys.bySubscriberSignatureId(subscriberSignatureId), "send-reminder"] as const,
  bySubscriberSignatureId: (subscriberSignatureId: number) =>
    [...SignatureQueryKeys.all, "subscriber-signature", subscriberSignatureId] as const,
  cancel: (subscriberSignatureId: number) =>
    [...SignatureQueryKeys.bySubscriberSignatureId(subscriberSignatureId), "cancel"] as const,
  sendCustomerServiceCertificate: (siteId: number) =>
    [...SignatureQueryKeys.bySiteId(siteId), "send-customer-service-certificate"] as const,
};
